import { UnderstandingResult } from "src/models/understanding";
import { createEntityModel } from "src/store/models/entity/_shared";

export const UnderstandingResultEntityModel = createEntityModel<
  UnderstandingResult
>();
